import React from 'react';
import { motion } from 'framer-motion';
import { ContactForm } from './ContactForm';
import { WaveBackground } from './WaveBackground';
export function HeroSection() {
  return <section className="relative min-h-screen flex items-center bg-[#0A1628] overflow-hidden pt-32 pb-20 lg:pt-28 lg:pb-16" data-id="element-70">
      <WaveBackground data-id="element-71" />

      <div className="container mx-auto px-6 sm:px-12 lg:px-24 xl:px-32 2xl:px-40
 relative z-10" data-id="element-72">
        <div className="flex flex-col lg:flex-row items-start justify-between gap-12 lg:gap-16" data-id="element-73">
          {/* Left Content */}
          <motion.div initial={{
          opacity: 0,
          x: -50
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} className="flex-1 text-center lg:text-left" data-id="element-74">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-6 font-playfair" data-id="element-75">
              Grow Your Dealership With Marketing{' '}
              <span className="text-[#D4AF37]" data-id="element-76">Built for Boat Sales</span>
            </h1>

            <p className="text-lg md:text-xl text-gray-300 mb-10 leading-relaxed max-w-xl mx-auto lg:mx-0" data-id="element-77">
              Boat buyers are searching every single day - if they can't find
              you, they'll find your competitors. Our marine-specialized digital
              marketing turns your website, ads, and online presence into a
              sales machine built for today's boat-buying behavior.
            </p>

            {/* Device Mockup Image */}
            <motion.div initial={{
            opacity: 0,
            y: 30
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.4,
            duration: 0.8
          }} className="hidden lg:block" data-id="element-78">
              <img src="https://cdn.magicpatterns.com/uploads/wvXsFFEghshvXmP4oEK5TN/bluewater-marine-device.jpg-Photoroom.png" alt="Bluewater Marine website on devices" className="w-full max-w-lg mx-auto lg:mx-0" data-id="element-79" />
            </motion.div>
          </motion.div>

          {/* Right Content - Form */}
          <div className="w-full max-w-md flex justify-center lg:justify-end" data-id="element-80">
            <ContactForm data-id="element-81" />
          </div>
        </div>
      </div>
    </section>;
}